module.exports = __webpack_public_path__ + "static/media/nitrox_logo_1200x628.2111de7e.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/nitrox_logo_1200x628.png
// module id = 600
// module chunks = 0